module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_cn.6f81606f.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_cn.jpg
// module id = 2977
// module chunks = 11